import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from "@angular/common/http";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ToastrModule } from "ngx-toastr";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
import { LoginComponent } from "./auth/login/login.component";
import { AppHttpInterceptor } from './shared/httpInterceptor/app-http-interceptor';
import { AdminComponent } from './components/admin/admin.component';
import { RegisterFormComponent } from './auth/register-form/register-form.component';
import { ModuleComponent } from "./components/module/module.component";
import { RouterModule } from "@angular/router";
import { InstituteComponent } from './components/institute/institute.component';
import { SpocComponent } from './components/spoc/spoc.component';
import { MentorComponent } from './components/mentor/mentor.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgxEditorModule } from 'ngx-editor';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { BsDatepickerModule, BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { ViewSharedFeaturesComponent } from './auth/view-shared-features/view-shared-features.component';
import { ViewPublishedFeaturesComponent } from './auth/view-published-features/view-published-features.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { CommonModule } from "@angular/common";
import { DemoVideoComponent } from './auth/demo-video/demo-video.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./i18n/");
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AdminComponent,
    RegisterFormComponent,
    ModuleComponent,
    InstituteComponent,
    SpocComponent,
    MentorComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent, ViewSharedFeaturesComponent, ViewPublishedFeaturesComponent, ResetPasswordComponent, DemoVideoComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    CommonModule,
    BsDatepickerModule.forRoot(),
    NgxMaterialTimepickerModule,
    RouterModule,
    ToastrModule.forRoot(),
    NgSelectModule,
    NgxChartsModule,
    CKEditorModule,
    NgxEditorModule,
    NgxSliderModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ToastrModule.forRoot({
      timeOut: 1000,
      extendedTimeOut: 1000,
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }